
import { Component, Emit, Prop } from '@modules/vue-property-decorator';
import Vue from 'vue';
import { CheckoutPaymentData, Transport } from './checkoutPayment.vue';
import { Format } from '@shared/core/helpers/formatHelper';
import Navigation from '@shared/components/navigation/navigation.vue';
import Container from '@shared/components/container/container.vue';
import CircleIcon from '@shared/components/container/circleIcon.vue';
import store from "@shared/core/store";

@Component({
  components: {
    Navigation,
    Container,
    CircleIcon,
  },
})
export default class CheckoutTransport extends Vue {
  @Prop({ required: true }) private data!: CheckoutPaymentData;
  @Prop({ default: null }) private value!: Transport|null; // selectedTransport

  private get isDarkMode() {
    return store.state.settings.DarkMode === true;
  }

  private get originAddress() {
    return this.$store.state.settings.Address;
  }

  private get destinationAddress() {
    return `${this.data.addressLine1} - ${this.data.postalCode} - ${this.data.town} (${this.data.city})`;
  }

  @Emit("input")
  private selectTransport(transport: Transport) {
    this.value = transport;
    return transport;
  }

  private getImagePath(img: string|null): string {
    if (!img) {
      return this.$store.state.settings.Uploads + "/" + this.$store.state.settings.Mainlogo;
    }
    return this.$store.state.settings.Uploads + "/" + img;
  }

  private formatPrice(price: string) {
    return Format.formatCurrency(price);
  }
}

